<template>
  <section class="relative">
    <div v-if="loading" class="rounded-md icono-carga p-8 pos-loading">
      <LoadingIcon icon="puff" color="rgba(0,0,0,0.4)" />
    </div>
    <div class="box w-full" style="overflow:hidden;">
      <div
      id="grafica"
      ref="elGrafica"
      style="height:500px;"
      class="w-full"
      />
    </div>
  </section>
</template>

<script>
import * as echarts from 'echarts'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { apiTopComprasProveedores } from '../../services'
// import { truncate } from 'lodash'
import currency from 'currency.js'
import { useStore } from 'vuex'
const navegadorVentanaAncho = 1024
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const store = useStore()
    const isDark = computed(() => {
      return store.getters['main/darkMode']
    })
    watch(props.filters, (filter) => {
      if ([null, undefined, ''].includes(filter)
      ) return
      fetchResults(filter)
    })
    /*
    * Refs and reactives
    */
    const gradesRotation = ref(0)
    const positionLabel = ref('insideTop')
    const distanceLabel = ref(10)
    const loading = ref(false)
    const colorLabel = ref('white')
    const elGrafica = ref(null)
    let chart = reactive({})
    const chartData = ref([])
    const chartDataTipo = ref([])
    /*
    * Methods
    */
    const initChart = () => {
      gradesRotation.value = (window.innerWidth < 1000) ? 90 : 0
      positionLabel.value = (window.innerWidth < 1000) ? 'top' : 'top'
      distanceLabel.value = (window.innerWidth < 1000) ? 25 : 10
      colorLabel.value = (window.innerWidth < 1000 && !isDark.value) ? 'gray' : 'gray'
      chart = echarts.init(elGrafica.value, isDark.value ? 'dark' : 'light')
      const option = {
        backgroundColor: isDark.value ? '#313A55' : '',
        title: {
          top: 15,
          left: 15,
          text: 'Top Compras por Proveedores'
        },
        grid: {
          left: 0,
          right: 15,
          bottom: 50,
          top: 85,
          containLabel: true
        },
        toolbox: {
          top: 15,
          right: 15,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            saveAsImage: {}
          }
        },
        tooltip: {
          top: 0,
          position: (pos) => {
            if (window.innerWidth > navegadorVentanaAncho) {
              return pos[0]
            } else {
              return ['5%', '0']
            }
          },
          formatter (a) {
            let Tipos = ''
            var array = getChartTipo(a)
              Tipos = Tipos + `<div class="title-tool"><p style="width:60%">${a.name}<p><p style="width:35%;text-align: right;">${currency(a.data, { precision: 0, separator: '.' }).format()}<p></div><br/>`
              for (let index = 0; index < array.length; index++) {
              Tipos = Tipos + `<div style="display:flex;width:250px;"><p style="width:75%">${array[index].tipo}<p><p style="width:25%;text-align: right;">${array[index].cant}<p></div>`
              }
            return Tipos
          }
        },
        legend: {
          show: false,
          data: ['Medicos']
        },
        yAxis: [
          {
            show: false
          }
        ],
        xAxis: {
          data: getChartLabels(),
          axisLabel: {
            interval: 0,
            fontSize: 10,
            width: 60,
            overflow: 'break'
            // formatter (value) {
            //   return value.split(' ').join('\n')
            // }
          }
        },
        series: [
          {
            name: 'Medicos',
            type: 'bar',
            showBackground: true,
            data: getChartData(),
            itemStyle: {
              borderRadius: 9,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              color: colorLabel.value,
              position: positionLabel.value,
              rotate: gradesRotation.value,
              verticalAlign: 'middle',
              distance: distanceLabel.value,
              formatter (d) {
                return `${currency(d.value / 1000000, { precision: 0, separator: '.' }).format()}M`
              }
            }
          }
        ]
      }
      if (window.innerWidth < 1024) {
        option.xAxis.show = false
      }
      chart.setOption(option)
      loadEvents()
    }
    const loadEvents = () => {
      window.addEventListener('resize', (evt) => {
        gradesRotation.value = (evt.target.innerWidth < 1000) ? 90 : 0
        positionLabel.value = (evt.target.innerWidth < 1000) ? 'top' : 'top'
        distanceLabel.value = (evt.target.innerWidth < 1000) ? 25 : 10
        colorLabel.value = (window.innerWidth < 1000 && !isDark.value) ? 'gray' : 'gray'
        reloadChart()
        chart.resize()
      })
    }

    const reloadChart = () => {
      const option = {
        xAxis: {
          data: getChartLabels(),
          show: true
        },
        series: [
          {
            showBackground: true,
            name: 'Medicos',
            type: 'bar',
            data: getChartData(),
            label: {
              show: true,
              color: colorLabel.value,
              position: positionLabel.value,
              rotate: gradesRotation.value,
              verticalAlign: 'middle',
              distance: distanceLabel.value
            }
          }
        ]
      }

      if (window.innerWidth < 1024) {
        option.xAxis.show = false
      }

      chart.setOption(option)
    }

    const getChartData = () => {
      return chartData.value.map(a => a.Total)
    }

    const getChartLabels = () => {
      return chartData.value.map(a => a.CardName)
    }
    const getChartTipo = (cliente) => {
      var ti = chartDataTipo.value.map(a => a)
      var tipo = ti.filter(c => c.cliente.includes(cliente.name))
      return tipo
    }
    const setChartData = (values = []) => {
      chartData.value = values.data
    }

    watch(() => props.filters, (filter) => {
      if ([null, undefined, ''].includes(filter)
      ) return
      fetchResults(filter)
    })

    const fetchResults = (filters) => {
      loading.value = true
      return apiTopComprasProveedores(filters).then(({ data, status }) => {
        // console.log('dataTop', data)
        setChartData(data)
        reloadChart()
      }).catch((err) => {
        console.error(err.message)
      }).finally(() => {
        loading.value = false
      })
    }

    // const fetchResultsTipo = (filters) => {
    //   loading.value = true
    //   return apiClienteTipoPqr(filters).then(({ data, status }) => {
    //     setChartTipo(data)
    //     reloadChart()
    //   }).catch((err) => {
    //     console.error(err.message)
    //   }).finally(() => {
    //     loading.value = false
    //   })
    // }

    /*
    * Hooks
    */
    onMounted(() => {
      fetchResults(props.filters)
      initChart()
    })

    return {
      chart,
      loading,
      elGrafica
    }
  }
}
</script>

<style>
.pos-loading {
  height:350px;
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  z-index:1;
  width:100%
}
</style>
